export default "__VITE_ASSET__CZmfVyPo__"